import { getLocaleNamespace } from '@wix/wixstores-client-core/dist/es/src/getLocaleNamespace';
export function multilingualService(publicData, widgetSettings, multiLangFields, defaultLocale) {
    var isPrimaryLanguage;
    var lang;
    if (multiLangFields) {
        isPrimaryLanguage = multiLangFields.isPrimaryLanguage;
        lang = multiLangFields.lang;
    }
    else {
        isPrimaryLanguage = true;
        lang = defaultLocale;
    }
    return {
        get: function (key) {
            if (isPrimaryLanguage) {
                return publicData && publicData[key];
            }
            else {
                var widgetSettingsTextsMap = widgetSettings[getLocaleNamespace(lang)];
                return widgetSettingsTextsMap && widgetSettingsTextsMap[key];
            }
        },
    };
}
//# sourceMappingURL=multilingualService.js.map